/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="position-relative">
    <b-form-textarea
      :id="_uid + '_' + name"
      v-model="valueComputed"
      :name="name"
      :state="validState"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :ref="name"
      :required="required"
      :disabled="disabled"
      :readonly="readonly"
      :data-vv-scope="dataVvScope"
      :rows="rows"
      :number="number"
      @change="$emit('change', $event)"
      @blur.native="$emit('blur')"
      >
    </b-form-textarea>
    <b-form-invalid-feedback >
      <!-- This will only be shown if the preceeding input has an invalid state -->
      <div v-for="(validation, index) in validationsFiltered"
        :key="index">
        {{ validation.text }}
      </div>
    </b-form-invalid-feedback>
    <b-form-text v-if="info">
      <!-- this is a form text block (formerly known as help block) -->
      {{ info }}
    </b-form-text>
  </div>
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    label: {
      type: String
    },
    value: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    info: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    dataVvScope: {
      type: String
    },
    rows: {
      type: Number,
      default: 3
    },
    number: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    validState () {
      let state = null
      for (let validation of this.validations) {
        if (validation.condition) {
          state = false
          break
        }
      }
      return state
    },
    validationsFiltered () {
      return this.validations.filter(v => v.condition)
    }
  },
  mounted () {
    if (this.focus) {
      this.$refs[this.name].focus()
    }
  }
}
</script>
